import { useLocation, useNavigate } from "react-router";
import React, { useState, useEffect, useMemo } from "react";
import { PTable } from './pTable';
import { getFilters } from './config';

export const PublicationTable = ({
  state,
  options,
  tabValue = 'published',
  columns,
  data = {},
  activeTab,
  mod = 'pme',
  selectOption = null,
  rowSelection,
  t = (s) => s,
  published = {},
  unPublished = {},
  setData = () => { },
  reset = false,
  setUnpublishedCountAll = () => { },
  setActiveFilters = () => { },
}) => {
  const goTo = useNavigate();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const defaultPublishedFilters = useMemo(() => getFilters(params, 'published', state), []);
  const defaultUnPublishedFilters = useMemo(() => getFilters(params, 'unPublished', state), []);

  const [publishedFilters, setPublishedFilters] = useState(defaultPublishedFilters);
  const [unpublishedFilters, setUnpublishedFilters] = useState(defaultUnPublishedFilters);

  const filters = useMemo(() => {
    return {
      published: publishedFilters,
      unPublished: unpublishedFilters,
    }
  }, [publishedFilters, unpublishedFilters]);

  useEffect(() => {
    if (activeTab === state) {
      goTo(`${location.pathname}?activeTab=${state}&published=${JSON.stringify(filters.published)}&unPublished=${JSON.stringify(filters.unPublished)}&tabValue=${tabValue}`);
    }
  }, [filters, activeTab, tabValue]);

  const fetchOptions = { view: 'publication', project: data.id };

  return (
    <>
      <div style={{ display: tabValue !== 'published' ? undefined : 'none' }}>
        <PTable
          columns={columns}
          rowSelection={rowSelection}
          data={unPublished}
          setActiveFilters={setActiveFilters}
          state={state}
          t={t}
          setData={setData}
          selectOption={selectOption}
          mod={mod}
          reset={reset}
          defaultActiveFilters={publishedFilters}
          onActiveFiltersChange={setPublishedFilters}
          options={options}
          fetchOptions={fetchOptions}
          setUnpublishedCountAll={setUnpublishedCountAll}
        />
      </div>
      <div style={{ display: tabValue === 'published' ? undefined : 'none' }}>
        <PTable
          columns={columns}
          t={t}
          reset={reset}
          selectOption={selectOption}
          onActiveFiltersChange={setUnpublishedFilters}
          defaultActiveFilters={unpublishedFilters}
          data={published}
          setData={setData}
          mod={mod}
          published
          state={state}
          options={options}
          fetchOptions={fetchOptions}
        />
      </div>
    </>
  );
}

/**
 * Fetch Options before
    country: data.country,
    view: 'publication',
    project: data.id,
    administrativeLevel1: data.provinces,
 */
